exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#notification .card{\n    border: 1px solid #dadada;\n    padding: 20px 40px;\n    margin-bottom: 15px;\n    border-radius: 4px;\n    background-color: #fff;\n}\n\n#notification .body{\n    height: 234px;\n    margin-left: 10px;\n}\n\n.empty-msg{\n    margin: 40px;\n}\n\n.empty-msg p{\n    color: #a3a3a3;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/view-notification/view-notification.component.css
// module id = ../../../../../src/app/pages/view-notification/view-notification.component.css
// module chunks = main